module.exports = __webpack_public_path__ + "img/compact.b95bac33.png";